import { User } from 'generated-graphql/types';
import { atom } from 'recoil';
import { sessionStorageEffect } from 'services/storage/sessionStorage';

enum StateKey {
  UserState = 'UserState'
}

export const userAtom = atom<User | null>({
  key: StateKey.UserState,
  default: null,
  effects: [sessionStorageEffect(StateKey.UserState)]
});
